import { Dialog } from 'primereact/dialog';
import classes from './summary.module.scss';
import { Button } from 'primereact/button';

const SummaryModal = ({
  visibility,
  toggleVisibility,
  forecastingMonths,
  getConstrainedForecast,
  directNDCheading,
  indirectNDCheading,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
  forecastingMonths: { label: string; dateString: string }[];
  getConstrainedForecast: (ndc: string, forecastMonthIndex: number) => string;
  directNDCheading: { ndc: string; packSize: string }[];
  indirectNDCheading: { ndc: string; packSize: string }[];
}) => {
  return (
    <Dialog
      visible={visibility}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
      headerStyle={{ display: 'none' }}
      contentStyle={{ padding: '0', margin: '0', borderRadius: '10px' }}
      closable={false}
    >
      <div>
        <div
          className={classes.headingContainer}
          style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}
        >
          <h3>Direct</h3>
        </div>
        {directNDCheading.length > 0 ? (
          <div className={classes.tableContainer}>
            <table>
              <thead>
                <td className={classes.datatablelay}>NDC11</td>
                {forecastingMonths.map(month => {
                  return <td className={classes.datatablelay}>{month.label}</td>;
                })}
              </thead>
              <tbody>
                {directNDCheading.map(ndc => {
                  return (
                    <tr>
                      <td>{ndc.ndc}</td>
                      {forecastingMonths.map((month, forecastMonthIndex) => {
                        return (
                          <td>
                            <td style={{ border: 'none', padding: '0' }}>
                              {getConstrainedForecast(ndc.ndc, forecastMonthIndex)}
                            </td>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={classes.noDataContainer}>No NDC found for Direct Selling category</div>
        )}
      </div>

      <div>
        <div className={classes.headingContainer}>
          <h3>Indirect</h3>
        </div>
        {indirectNDCheading.length > 0 ? (
          <div className={classes.tableContainer}>
            <table>
              <thead>
                <td className={classes.datatablelay}>NDC11</td>
                {forecastingMonths.map(month => {
                  return <td className={classes.datatablelay}>{month.label}</td>;
                })}
              </thead>
              <tbody>
                {indirectNDCheading.map(ndc => {
                  return (
                    <tr>
                      <td>{ndc.ndc}</td>
                      {forecastingMonths.map((month, forecastMonthIndex) => {
                        return (
                          <td style={{ border: 'none', padding: '0' }}>
                            {getConstrainedForecast(ndc.ndc, forecastMonthIndex)}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={classes.noDataContainer}>No NDC found for Indirect Selling category</div>
        )}
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={toggleVisibility} className={classes.cancelButton}>
          Cancel
        </Button>
      </div>
    </Dialog>
  );
};

export default SummaryModal;
